import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";
import { addRubberlinePoint, interactionFloatingPaletteInput, interactionFloatingPaletteInputEnd } from "../../../../store/interaction";
import PaletteLines, { FloatingPaletteLineList, PaletteLinesProps } from "../../modals/FloatingPalette/PaletteLines";
import { useAppSelector } from "../../../../store/hooks";

export interface PaletteRefProps {
  toggle: () => void,
  backspace: () => void,
  onNumberInput: (key: "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "0") => void,
}

interface LineFloatingPaletteProps {
}
const LineFloatingPalette = forwardRef<PaletteRefProps, LineFloatingPaletteProps>((props, ref) => {
  const dispatch = useDispatch();
  const editorState = useAppSelector((state) => state.interaction.editorState);
  const rubberlinePoints = useAppSelector(state => state.interaction.rubberlineData.pointerPoints);
  const [lineToEdit, setLineToEdit] = useState<keyof Point2d>("x");
  const [currentInput, setCurrentInput] = useState<Point2d>({ x: 0, y: 0, });
  const [deltaInput, setDeltaInput] = useState<boolean>(false);
  const [currentInputPoint, setCurrentInputPoint] = useState<Point2d>({ x: 0, y: 0, });

  const setPointPosition = useCallback(function (point: Point2d, isDelta: boolean) {

    const lastPoint = rubberlinePoints[rubberlinePoints.length - 1];
    if (isDelta && lastPoint) {
      const deltaPoint = { x: point.x + lastPoint.x, y: point.y + lastPoint.y };
      setCurrentInputPoint(deltaPoint);
      dispatch(interactionFloatingPaletteInput(deltaPoint));
    } else {
      setCurrentInputPoint(point)
      dispatch(interactionFloatingPaletteInput(point));
    }
  }, [rubberlinePoints, dispatch])

  useEffect(() => {
    const linePalette = (ev: KeyboardEvent) => {
      console.log("palette input");
      switch (ev.key) {
        case "d": {
          const newIsDelta = !deltaInput
          setDeltaInput(newIsDelta);
          setPointPosition(currentInput, newIsDelta);
          break;
        }
        case "Enter":
          dispatch(addRubberlinePoint({ endOfInput: false, pointerPoint: currentInputPoint, snapPoint: currentInputPoint }));
          dispatch(interactionFloatingPaletteInputEnd());
          setCurrentInput({ x: 0, y: 0 })
          setLineToEdit("x")
          break;
        case "Escape":
          console.log("escape end palette input");
          setLineToEdit("x")
          break
      }
    }
    window.addEventListener("keydown", linePalette);
    return () => window.removeEventListener("keydown", linePalette);
  }, [editorState, dispatch, currentInput, deltaInput, currentInputPoint, setPointPosition])

  const toggleInput = () => {
    setLineToEdit(lineToEdit === "x" ? "y" : "x");
  }



  useImperativeHandle(ref, () => ({
    toggle: toggleInput,
    backspace: () => {
      const position = { ...currentInput, [lineToEdit]: Math.trunc(currentInput[lineToEdit] / 10) };
      setCurrentInput(position);
      setPointPosition(position, deltaInput);
    },
    onNumberInput: (key) => {
      const position = { ...currentInput, [lineToEdit]: currentInput[lineToEdit] * 10 + parseInt(key) };
      setCurrentInput(position);
      setPointPosition(position, deltaInput);
    },
  }))

  const delta = deltaInput ? 'd' : '';
  const lineList: FloatingPaletteLineList<Point2d> = {
    x: { name: `x${delta} axis`, inputName: "x", inputType: "number" },
    y: { name: `y${delta} axis`, inputName: "y", inputType: "number" },
  }

  return (
    <>
      {rubberlinePoints.length > 0 && <LineDefinitionPalette paletteLines={{ argList: lineList, currentInput: currentInput, lineToEdit: lineToEdit }} />}
      {rubberlinePoints.length === 0 && <PointDefinitionPalette paletteLines={{ argList: lineList, currentInput: currentInput, lineToEdit: lineToEdit }} />}
    </>
  )
})
const PointDefinitionPalette = ({ paletteLines }: { paletteLines: PaletteLinesProps<Point2d> }) => {
  return (
    <>
      <div>FirstPoint</div>
      <PaletteLines argList={paletteLines.argList} currentInput={paletteLines.currentInput} lineToEdit={paletteLines.lineToEdit} />
    </>
  )
}
const LineDefinitionPalette = ({ paletteLines }: { paletteLines: PaletteLinesProps<Point2d> }) => {
  return (
    <>
      <div>Line</div>
      <PaletteLines argList={paletteLines.argList} currentInput={paletteLines.currentInput} lineToEdit={paletteLines.lineToEdit} />
    </>
  )
}

export function createLineFloatingPalette(paletteRef: React.RefObject<PaletteRefProps>) {
  return <LineFloatingPalette ref={paletteRef} />;
}

export default LineFloatingPalette;